import { faCoins, faEye, faEyeSlash, faTags } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext } from "react";
import { Button, Card, Col, Container, Modal, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { faCreditCard, faUser, faCalendar } from "@fortawesome/free-regular-svg-icons";
import { BasicContext } from "../../App";

const DiscountCodeUsageModal = (props) => {
    const { t } = useTranslation();
    const { onClose, code } = props;
    const { changeView } = useContext(BasicContext);

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("codes.discountCodeDetails")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <Card className="shadow-sm mb-3">
                                <Card.Body className="p-2">
                                    <Container fluid>
                                        <Row>
                                            <Col>
                                                <p className="text-bold mb-1">{code.discount_code_name}</p>
                                                <p className="mb-1">
                                                    <FontAwesomeIcon icon={faTags} className="me-1 me-lg-2" />
                                                    {code.discount_value ? (
                                                        <>
                                                            {code.discount_value} {t("currency")}
                                                        </>
                                                    ) : (
                                                        <>{code.discount_rate} %</>
                                                    )}
                                                </p>
                                                <p>
                                                    <FontAwesomeIcon icon={code.discount_code_visible === "Y" ? faEye : faEyeSlash} className="me-1 me-lg-2" />
                                                    {t(code.discount_code_visible === "Y" ? "visible" : "invisible")}
                                                </p>
                                            </Col>
                                            <Col className="text-end">
                                                <p className="mb-1">
                                                    {t("used")}:{" "}
                                                    <span className="text-bold">
                                                        {code.discount_code_usage.length}
                                                        {code.discount_code_quantity && <>/{code.discount_code_quantity}</>}
                                                    </span>
                                                </p>
                                                <p className="mb-1 text-small">
                                                    {t("created")}: <span className="text-bold">{moment(code.discount_code_start_date).format("DD.MM.YYYY")}</span>
                                                </p>
                                                <p className="text-small">{t(`codes.${code.discount_multiple_usage === "Y" ? "multipleUsageCode" : "singleUsageCode"}`)}</p>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <p className="h6 mb-3">{t("codes.codesUsage")}</p>
                        </Col>
                        <Col xs={12}>
                            {code.discount_code_usage.length === 0 ? (
                                <p className="fs-6 opacity-50">{t("codes.codeWasNotUsedYet")}</p>
                            ) : (
                                <Table className="white-table" size="sm" style={{ border: "1px solid #4a4a4a" }}>
                                    <tbody>
                                        {code.discount_code_usage.map((e, i) => (
                                            <Fragment key={i}>
                                                <tr>
                                                    <td className="border-bottom-0 pb-0">
                                                        <FontAwesomeIcon icon={faUser} className="me-1 me-lg-2" />
                                                        <Button variant="link" onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: e.user_id } })}>
                                                            {e.buying_user_name}
                                                        </Button>
                                                    </td>
                                                    <td className="border-bottom-0 pb-0 text-end">
                                                        <FontAwesomeIcon icon={faCreditCard} className="me-1 me-lg-2" />
                                                        {e.pass_name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <FontAwesomeIcon icon={faCalendar} className="me-1 me-lg-2" />
                                                        {moment(e.up_purchase_date).format("DD.MM.YYYY")}
                                                    </td>
                                                    <td className="text-end">
                                                        <FontAwesomeIcon icon={faCoins} className="me-1 me-lg-2" />
                                                        {e.up_price} {t("currency")}
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onClose}>
                    {t("close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DiscountCodeUsageModal;
